import { ConsentState } from '@auth/components/ConsentSection';

export interface ConsentValidationErrors {
    agb?: string;
    datenschutz?: string;
}

export const validateConsent = (consents: ConsentState): ConsentValidationErrors => {
    const errors: ConsentValidationErrors = {};

    if (!consents.agbAccepted) {
        errors.agb = 'Die Zustimmung zu den AGB ist erforderlich';
    }

    if (!consents.datenschutzAccepted) {
        errors.datenschutz = 'Die Zustimmung zur Datenschutzerklärung ist erforderlich';
    }

    return errors;
};

export const isConsentValid = (consents: ConsentState): boolean => {
    const errors = validateConsent(consents);
    return Object.keys(errors).length === 0;
}; 